module.exports = __webpack_public_path__ + "img/Don't-worry-th.ffed273.png";